<p>
  Излизането от профила е важна стъпка за защита на личните ви данни, особено ако използвате споделено или обществено
  устройство. Това гарантира, че други лица няма да имат достъп до вашата информация, настройки или активност в
  платформата.
</p>
<h6 class="mt-3">Кога е препоръчително да излезете?</h6>
<p class="mb-1">
  Излизането от профила е силно препоръчително:
</p>
<ul>
  <li>когато използвате чужд или публичен компютър (например в библиотека, офис, интернет клуб и др.);</li>
  <li>когато работите на собствено устройство, което не е защитено с парола или автоматично заключване;</li>
  <li>след приключване на активност в профила – особено ако оставяте устройството без надзор.</li>
</ul>
<h6 class="mt-3">Как да излезете от профила си?</h6>
<ol>
  <li>Навигирайте до <strong>менюто „Профил“</strong> в горната част на сайта.</li>
  <li>Изберете опцията <strong>„Изход“</strong> от падащото меню.</li>
</ol>
<h6 class="mt-3">Какво се случва след излизане?</h6>
<p>
  След като излезете успешно от профила си, ще бъдете пренасочени към страницата за вход. Оттам може:
</p>
<ul>
  <li>да влезете с друг профил;</li>
  <li>или да продължите разглеждането на сайта като <strong>нерегистриран потребител</strong>.</li>
</ul>
<p>
  Излизането не изтрива вашия акаунт. Всички ваши обяви, съобщения, рейтинги и настройки се запазват и ще бъдат налични
  при следващо влизане.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Излизайте от акаунта си редовно, особено при ползване на чужди устройства, за да предотвратите
  неоторизиран достъп до личната ви информация.
</div>
